export interface ManufacturingScanBreakdownLine {
  sku: string;
  description: string | null;
  quantity: number;
  counted: boolean;
  kind: "serialized" | "unserialized" | "accessory" | "session" | "line";
}

export function mergeBreakdownLines(
  lines: readonly ManufacturingScanBreakdownLine[],
): ManufacturingScanBreakdownLine[] {
  const byKey = new Map<string, ManufacturingScanBreakdownLine>();
  for (const line of lines) {
    const sku = line.sku.trim() || "(unknown)";
    const key = `${sku}\0${line.counted ? "1" : "0"}\0${line.kind}`;
    const existing = byKey.get(key);
    if (existing) {
      existing.quantity += line.quantity;
      if (!existing.description && line.description) {
        existing.description = line.description;
      }
      continue;
    }
    byKey.set(key, { ...line, sku, quantity: line.quantity });
  }
  return [...byKey.values()]
    .filter((line) => line.quantity > 0)
    .sort((left, right) => right.quantity - left.quantity || left.sku.localeCompare(right.sku));
}
